import React from 'react'
import { useAuth } from '../../contexts/AuthContext'
import Sidebar from '../Sidebar/Sidebar'
import FeatureAccessGate from './FeatureAccessGate'
import { PORTAL_ROLES } from '../Sidebar/portalNav'

/**
 * Standard users: Sidebar + main content.
 * GP/LP: portal layout (180px sidebar + design tokens).
 */
export default function PageShell({ embedded = false, fullBleed = false, children }) {
  const { role, isAdmin } = useAuth()
  const usePortal = PORTAL_ROLES.includes(role) && !isAdmin

  if (embedded) {
    return (
      <div className={fullBleed ? 'admin-embedded-bleed' : 'admin-embedded-content'}>
        {children}
      </div>
    )
  }

  if (usePortal) {
    return (
      <div className="portal-layout">
        <Sidebar />
        <main className={`portal-main${fullBleed ? ' portal-main-flush' : ''}`}>
          <div className={fullBleed ? 'portal-content flush' : 'portal-content'}>
            <FeatureAccessGate>{children}</FeatureAccessGate>
          </div>
        </main>
      </div>
    )
  }

  return (
    <div className="flex min-h-screen bg-gray-50">
      <Sidebar />
      <div className={`flex-1 ml-[240px] ${fullBleed ? 'flex min-h-0' : 'p-8'}`}>{children}</div>
    </div>
  )
}
